
define('ldsh!modules/editor/templates/elements/button', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<a class="btn btn-default">\n  <span class="btn-label">label</span>\n</a>';

}
return __p
};});

